'use client';

import { ThemeColorValueImportance } from '@actr/style/src/specs/theme-v2';
import { Button, ButtonTypes } from '@actr/ui/src/components/_atoms/button';
import { Text } from '@actr/ui/src/components/_atoms/text';
import { FormInput } from '@actr/ui/src/components/_form/form-input';
import { InputSize } from '@actr/ui/src/components/_form/form-input/specs';
import { SelectInput, SelectInputItem } from '@actr/ui/src/components/_form/select-input';
import { ContentBlock } from '@actr/ui/src/components/content-block';
import { FormField } from '@actr/widgets/src/components/_common/form/form-field';
import { observer } from 'mobx-react-lite';
import React, { useMemo, useState } from 'react';

import * as Styled from './style.css';

export type SearchFormProps = {
  fromCity: string;
  title: string;
  flights: {
      name: string;
      url: string;
  }[] | null;
}

const SearchForm: React.FC<SearchFormProps> = ({ title, flights, fromCity }) => {
  const [cityTo, setCityTo] = useState('');

  const cities: SelectInputItem[] = useMemo(() => (flights?.map(item => ({
    value: item.name,
    label: item.name,
  })) || []) as SelectInputItem[], [flights]);

  function handleSearch() {
    if (!flights) return;
    const routeTo = flights.find(item => item.name === cityTo);
    if (routeTo) {
      window.location.href = `/${routeTo.url}`;
    }
    setCityTo('');
  }

  function handleChangeValue(value: string) {
    setCityTo(value);
  }

  if (!flights) {
    return null;
  }

  return (
    <ContentBlock className={Styled.Wrapper}>
      <Text tagName="h3" font="title.x2l">
        {title}
      </Text>
      <div className={Styled.SearchFormWrapper}>
        <FormField
          className={Styled.FormField}
          label={<Text font="paragraph.xs" color={ThemeColorValueImportance.LIGHTER}>Город вылета</Text>}>
          <FormInput
            size={InputSize.S}
            disabled={true}
            value={fromCity}
          />
        </FormField>
        <FormField
          className={Styled.FormField}
          label={<Text font="paragraph.xs" color={ThemeColorValueImportance.NORMAL}>Куда</Text>}>
          <SelectInput
            size={InputSize.S}
            placeholder="Выберите направление"
            items={cities}
            value={cityTo}
            onChange={handleChangeValue}
          />
        </FormField>
        <Button
          className={Styled.SearchButton}
          buttonType={ButtonTypes.PRIMARY}
          onClick={handleSearch}>
          Найти
        </Button>
      </div>
    </ContentBlock>
  );
};

export default observer(SearchForm);
